<template>
  <div class="pt-2 px-4">
    <div class="d-flex">
      <div class="w-100">
        <h4>Answer</h4>
        <v-select
          v-model="selectedOperator"
          :options="operators"
          label="label"
          value="value"
          :searchable="false"
          @input="updateTickets"
        ></v-select>
      </div>
      <div class="w-100 pl-3">
        <h4>Value</h4>
        <template
          v-if="selectedOperatorValue === '=' || selectedOperatorValue === '!='"
        >
          <v-select
            v-model="selectedAnswers"
            :options="tickets"
            :searchable="false"
            @input="updateTickets"
          ></v-select>
        </template>
        <template
          v-else-if="
            selectedOperatorValue === 'in' || selectedOperatorValue === 'not in'
          "
        >
          <v-select
            v-model="selectedAnswers"
            :options="tickets"
            multiple
            :searchable="false"
            @input="updateTickets"
          ></v-select>
        </template>
      </div>
    </div>

    <br />
  </div>
</template>

<script>
import vSelect from "vue-select";
import Service from "@/services";
export default {
  props: {
    tickets: {
      type: Array,
      default: () => [],
    },
    conditions: {
      type: Object,
    },
    onChange: {
      type: Function,
    },
  },
  components: {
    vSelect,
  },
  data() {
    return {
      isFirstFetch: true,
      operators: [
        {
          label: "is",
          value: "=",
        },
        {
          label: "is not",
          value: "!=",
        },
        {
          label: "is in",
          value: "in",
        },
        {
          label: "is not in",
          value: "not in",
        },
      ],
      selectedForm: null,
      selectedTicket: null,
      selectedOperator: null,
      selectedAnswer: null,
      selectedAnswers: [],
      textAnswer: null,
    };
  },
  watch: {
    conditions() {
      this.reverveGenerateConditionsArray();
    },
  },
  mounted() {
    this.reverveGenerateConditionsArray();
  },
  computed: {
    selectedOperatorValue() {
      if (!this.selectedOperator) return "";
      return this.selectedOperator.value;
    },
  },
  methods: {
    async updateTickets() {
      // try {
      //   // Make an API call to fetch questions based on the selected form ID
      //   const response = await fetch(`/api/questions?form_id=${this.selectedForm}`);
      //   const data = await response.json();
      //   this.questions = data.questions;
      // } catch (error) {
      //   console.error('Error fetching questions:', error);
      // }
      this.useGeneratedConditionsArray();
    },
    reverveGenerateConditionsArray() {
      if (!this.isFirstFetch || !this.conditions) {
        return;
      }
      if (
        !this.conditions.conditions ||
        this.conditions.conditions.length != 1
      ) {
        this.conditions.conditions = [
          {
            field: "ticket_type",
            operator: "=",
            value: "",
          },
        ];
      }
      this.selectedOperator = this.operators.find((o) => {
        return (
          o.value == this.conditions.conditions[0].operator ||
          o.label == this.conditions.conditions[0].operator
        );
      });
      this.selectedAnswers = Array.isArray(this.conditions.conditions[0].value)
        ? this.conditions.conditions[0].value.map((qv) =>
            this.tickets.find((qo) => qo.value == qv)
          )
        : this.tickets.find((qo) => {
            return qo.value == this.conditions.conditions[0].value;
          });
      this.isFirstFetch = false;
    },
    generateConditionsArray() {
      const conditionsArray = [];

      if (this.selectedOperator) {
        let value;
        value = Array.isArray(this.selectedAnswers)
          ? this.selectedAnswers.map((item) => item.value || item)
          : this.selectedAnswers.value || this.selectedAnswers;

        conditionsArray.push({
          field: "ticket_type",
          operator: this.selectedOperator.value,
          value: value,
        });
      }

      // Example: Add more conditions based on other component inputs

      return {
        logic_between_conditions: "AND", // You can customize this based on your requirement
        conditions: conditionsArray,
      };
    },

    // ... existing methods

    // Example: You can call this method when you need to use the generated array
    useGeneratedConditionsArray() {
      const generatedConditions = this.generateConditionsArray();
      this.$emit("update:conditions", generatedConditions);
      if (this.onChange) {
        this.onChange(generatedConditions);
      }
      // You can use the generated array as needed
    },
  },
};
</script>

<style scoped>
/* Your component styles here */
</style>
